(() => {
  const isArt = item => String(item.product_type || item.product?.type || '').trim() === 'Mosaic Art';
  const lineState = item => {
    const properties = item.properties || {};
    const width = Number(properties.Width);
    const height = Number(properties.Height);
    const quantity = Number(item.quantity);
    const grams = Number(item.grams ?? item.weight);
    const actual = width * height;
    const billed = Math.ceil(actual);
    const reasons = [];
    if (!(width > 0 && height > 0 && Number.isFinite(actual) && Number.isSafeInteger(billed))) reasons.push('invalid');
    if (!(grams > 0 && Number.isFinite(grams))) reasons.push('missing');
    if (!Number.isSafeInteger(quantity) || quantity < 1 || quantity !== billed) reasons.push('mismatch');
    if (/with frame/i.test(item.variant_title || item.public_title || item.title || '') && (width > 2 || height > 2)) reasons.push('framed');
    return {width, height, actual, billed, grams: grams > 0 ? grams * quantity : 0, reasons};
  };
  const cartState = (cart, incompatibleVariantIds = []) => {
    const items = (cart.items || []).filter(isArt);
    const lines = items.map(lineState);
    const grams = lines.reduce((total, line) => total + line.grams, 0);
    const reasons = [...new Set(lines.flatMap(line => line.reasons))];
    if (grams > 90000) reasons.push('oversize');
    const incompatible = new Set(incompatibleVariantIds.map(String));
    if (items.length && (cart.items || []).some(item => !isArt(item) && item.requires_shipping !== false && incompatible.has(String(item.variant_id || item.id)))) reasons.push('mixed_shipping');
    return {present: items.length > 0, quote: reasons.length > 0, grams, reasons};
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = {isArt, lineState, cartState};
  if (typeof document === 'undefined') return;
  const configNode = document.getElementById('CocoArtShippingConfig');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const messages = config.messages;
  let pendingArtAdd = false;
  let lastState = {present: config.initial_status !== 'none', quote: config.initial_status === 'quote'};
  const bypass = new WeakSet();
  const quoteUrl = () => {
    const url = new URL(config.quote_url, window.location.origin);
    const state = document.getElementById('Coco-estimator-state')?.value;
    const postcode = document.getElementById('Coco-estimator-postcode')?.value.trim();
    const suburb = document.getElementById('Coco-estimator-suburb')?.value.trim();
    const states = {'Australian Capital Territory':'ACT','New South Wales':'NSW','Northern Territory':'NT','Queensland':'QLD','South Australia':'SA','Tasmania':'TAS','Victoria':'VIC','Western Australia':'WA'};
    if (states[state]) url.searchParams.set('art_state', states[state]);
    if (/^[0-9]{4}$/.test(postcode || '')) url.searchParams.set('art_postcode', postcode);
    if (suburb && suburb.length <= 100) url.searchParams.set('art_suburb', suburb);
    return url.pathname + url.search;
  };

  const fetchCart = async () => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 12000);
    try {
      const response = await fetch(config.cart_url + '.js', {credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'application/json'}, signal: controller.signal});
      if (!response.ok) throw new Error('failed');
      const cart = await response.json();
      if (!Array.isArray(cart.items)) throw new Error('failed');
      return cart;
    } finally { clearTimeout(timeout); }
  };
  const applyState = state => {
    lastState = state;
    document.documentElement.toggleAttribute('data-coco-art-present', state.present);
    document.querySelectorAll('button[name="checkout"]').forEach(button => {
      button.dataset.cocoArtQuoteRequired = String(state.quote);
      button.hidden = state.quote;
      if (!state.quote) return;
      const cta = button.closest('.cart__ctas') || button.parentElement;
      if (!cta.querySelector('[data-coco-art-quote-entry], [data-coco-art-dynamic-entry]')) {
        const entry = document.createElement('div');
        entry.dataset.cocoArtDynamicEntry = '';
        const note = document.createElement('p'); note.textContent = messages.quote;
        const link = document.createElement('a'); link.className = 'button'; link.href = quoteUrl(); link.textContent = messages.button;
        entry.append(note, link); cta.prepend(entry);
      }
    });
    document.querySelectorAll('[data-coco-art-quote-entry], [data-coco-art-dynamic-entry]').forEach(entry => { entry.hidden = !state.quote; });
    document.querySelectorAll('[data-coco-art-cart-note]').forEach(note => { note.hidden = !state.present; });
    document.querySelectorAll('.additional-checkout-buttons').forEach(container => { container.hidden = state.present; });
  };
  const report = message => {
    const target = document.querySelector('[data-coco-art-product-error]') || document.getElementById('cart-errors');
    if (target) {target.textContent = message; target.hidden = false; target.setAttribute('role', 'alert'); target.scrollIntoView({block: 'nearest'});}
    else window.alert(message);
  };
  const currentProduct = form => {
    const variant = config.product?.variants.find(item => String(item.id) === String(form.elements.id?.value));
    if (!variant) return null;
    const width = form.querySelector('[name="properties[Width]"]')?.value;
    const height = form.querySelector('[name="properties[Height]"]')?.value;
    return {product_type: 'Mosaic Art', variant_title: variant.title, grams: variant.weight, quantity: Math.ceil(Number(width) * Number(height)), properties: {Width: width, Height: height}};
  };
  const productUpdate = () => {
    document.querySelectorAll('.mosaic-form form').forEach(form => {
      const item = currentProduct(form); if (!item) return;
      const state = lineState(item);
      const invalid = state.reasons.includes('invalid');
      const area = form.querySelector('[data-coco-art-area]');
      if (area) area.textContent = invalid ? '' : messages.area.replace('__actual__', String(Number(state.actual.toFixed(6)))).replace('__billed__', String(state.billed));
      const actualInput = form.querySelector('[data-coco-art-actual]');
      const billedInput = form.querySelector('[data-coco-art-billed]');
      if (actualInput) actualInput.value = invalid ? '' : String(Number(state.actual.toFixed(6)));
      if (billedInput) billedInput.value = invalid ? '' : String(state.billed);
      if (!invalid && form.elements.quantity) form.elements.quantity.value = state.billed;
      const note = form.querySelector('[data-coco-art-product-note]');
      const reasons = invalid ? [] : state.reasons.filter(reason => reason !== 'invalid');
      if (state.grams > 90000) reasons.push('oversize');
      if (note) note.textContent = [...new Set(reasons)].map(reason => messages[reason]).concat(messages.regular).join(' ');
      const button = document.getElementById('dummy_btn_' + config.product.id);
      const text = button?.querySelector('span:not(.loading__spinner)');
      if (text && !button.classList.contains('loading')) text.textContent = reasons.length ? messages.add_quote : messages.add;
    });
  };
  const refresh = async redirect => {
    try {
      const cart = await fetchCart(); const state = cartState(cart, config.general_non_art_variant_ids); applyState(state);
      if (redirect && state.quote) window.location.assign(quoteUrl());
    } catch { if (redirect) window.location.assign(config.cart_url); }
  };
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.closest('.mosaic-form') && config.product) {
      const item = currentProduct(form); const state = item && lineState(item);
      if (!state || state.reasons.includes('invalid')) {
        event.preventDefault(); event.stopImmediatePropagation(); report(messages.invalid);
        const button = document.getElementById('dummy_btn_' + config.product.id);
        button?.classList.remove('loading'); button?.removeAttribute('aria-disabled');
        button?.querySelector('.loading__spinner')?.classList.add('hidden');
        return;
      }
      form.elements.quantity.value = state.billed;
      productUpdate(); pendingArtAdd = true;
      return;
    }
    const submitter = event.submitter;
    const checkout = submitter?.name === 'checkout' || /\/checkout(?:\?|$)/.test(form.action);
    if (!checkout || bypass.has(form)) {bypass.delete(form); return;}
    event.preventDefault(); event.stopImmediatePropagation();
    try {
      const state = cartState(await fetchCart(), config.general_non_art_variant_ids); applyState(state);
      if (state.quote) {window.location.assign(quoteUrl()); return;}
      bypass.add(form); form.requestSubmit(submitter || undefined);
    } catch {report(messages.failed);}
  }, true);
  document.addEventListener('click', async event => {
    const link = event.target.closest('a[href]');
    if (!link || link.origin !== window.location.origin) return;
    if (link.pathname === config.cart_url && new URL(link.href).searchParams.get('view') === 'art-delivery-quote') {link.href = quoteUrl(); return;}
    if (!/^\/checkout(?:\/|$)/.test(link.pathname)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    try {const state = cartState(await fetchCart(), config.general_non_art_variant_ids); applyState(state); window.location.assign(state.quote ? quoteUrl() : link.href);}
    catch {report(messages.failed);}
  }, true);
  const start = () => {
    applyState(lastState); productUpdate();
    document.addEventListener('input', event => {if (event.target.closest('.mosaic-form')) productUpdate();});
    document.addEventListener('change', event => {if (event.target.closest('.mosaic-form')) setTimeout(productUpdate, 550);});
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, () => {const redirect = pendingArtAdd; pendingArtAdd = false; refresh(redirect);});
    document.addEventListener('shopify:section:load', () => {productUpdate(); refresh(false);});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.CocoArtShipping = {lineState, cartState: cart => cartState(cart, config.general_non_art_variant_ids), refresh};
})();
